/* esm.sh - buffer@6.0.3 */
import "/base64-js@^1.3.1?target=esnext";
import "/ieee754@^1.2.1?target=esnext";
export * from "/buffer@6.0.3/esnext/buffer.mjs";
export { default } from "/buffer@6.0.3/esnext/buffer.mjs";
